import { CustomerAccountComponent, CustomerAccountVisitsComponent, CustomerAccountDetailsComponent } from '@app/customer-account';
import {
  UserLoggedInGuard
} from '@app/shared/guards';
import { Routes } from "@angular/router";

export const customerAccountModuleRoutes: Routes = [
  {
    path: 'account',
    component: CustomerAccountComponent,
    canActivate: [UserLoggedInGuard],
    children: [
      {
        path: 'details',
        data: { bodyCssClass: 'bjootify-customer-account' },
        component: CustomerAccountDetailsComponent
      },
      {
        path: 'visits',
        data: { bodyCssClass: 'bjootify-customer-account' },
        component: CustomerAccountVisitsComponent
      },
      { path: '**', redirectTo: 'details', pathMatch: 'full' }
    ]
  }
];
